import { render, staticRenderFns } from "./Mediathek.vue?vue&type=template&id=a5c25454&"
import script from "./Mediathek.vue?vue&type=script&lang=js&"
export * from "./Mediathek.vue?vue&type=script&lang=js&"
import style0 from "./Mediathek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports